// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b56ff570","337":"eefbc20a","453":"3573361f","455":"8738046f"}[chunkId] + ".chunk.js";
};